import JSONFormatter from "json-formatter-js";
import MarkJs from "mark.js";
import * as objectAssignDeep from "./tools/object-assign-deep";

export default class HcsDebugWindow
{
    constructor(paramObj) {
        let self = this;

        this.options = Object.assign({}, {
            enabled: true,
            containerId: null,
            minWidth: 60,
            minHeight: 40,
            identSelected: () => { return false; }
        }, paramObj);

        // Store original data objects for each view.
        this.dataLogs = {};

        if(this.options.enabled) {
            this.pane = document.getElementById(this.options.containerId);
            this.titleBar = this.pane.querySelector(".hcs-header");

            this.initWindowDnD();
            this.initJsonLogs();

            this.pane.querySelectorAll("nav > button").forEach((element) => {
                element.addEventListener("click", () => { self.changeTab(element.getAttribute("tabid")); });
            });

            this.pane.querySelector("button.hcs-hide").addEventListener("click", () => {
                self.pane.classList.toggle("hcs-hidden");
                self.dnd.enabled = !self.pane.classList.contains("hcs-hidden");
                if(self.dnd.enabled) {
                    self.animate();
                }
            });

            this.pane.querySelector("button.hcs-close").addEventListener("click", () => {
                self.dnd.enabled = false;
                this.pane.style.display = "none";
            });
        }

        this.initConsoleLog();

        if(this.options.enabled) {
            const debugPassword = window.cadclick.loader.getUrlParameterByName("hcs-debug-password");

            let settingsUrl = this.options.hcs.api.getUrl(`/settings/${this.options.hcs.cultureId}`);

            if(debugPassword) {
                settingsUrl = this.options.hcs.api.getUrl(`/settings_all/${debugPassword}/${this.options.hcs.cultureId}`);
            }

            this.options.hcs.api.callback({
                url: settingsUrl,
                method: "GET",
                showErrorMessage: false,
            }).then(result => {
                self.showSettings(result);
            });

            let currentTab = this.settings().currentTab;

            if(currentTab) {
                this.changeTab(currentTab);
            } else {
                this.changeTab("console");
            }
        }
    }

    htmlEscape(str) {
        return ((typeof str !== "undefined" && str !== null) ? str : "").toString()
            .replace(/>/g, "&gt;")
            .replace(/</g, "&lt;");
    }

    initWindowDnD() {
        this.dnd = {
            margins: 4,
            clicked: null,
            onRightEdge: 0,
            onBottomEdge: 0,
            onLeftEdge: 0,
            onTopEdge: 0,
            rightScreenEdge: 0,
            bottomScreenEdge: 0,
            b: null,
            x: 0,
            y: 0,
            mouseMoveEvent: null,
            redraw: false,
            titleBarHeight: this.titleBar ? this.titleBar.clientHeight : 30,
            enabled: true
        };

        let self = this;

        this.pane.addEventListener("mousedown", (e) => { self.onMouseDown.call(this, e); });
        document.addEventListener("mousemove", (e) => { self.onMove.call(this, e); });
        document.addEventListener("mouseup", (e) => { self.onUp.call(this, e); });

        this.pane.addEventListener("touchstart", (e) => { self.onTouchDown.call(this, e); });
        document.addEventListener("touchmove", (e) => { self.onTouchMove.call(this, e); });
        document.addEventListener("touchend", (e) => { self.onTouchEnd.call(this, e); });

        this.animate();
    }

    initConsoleLog() {
        let self = this;

        this.console = {
            debug: (text, dataObject) => { self._consoleAppend(text, { dataObject: dataObject, logType: "DEBUG" }); },
            info: (text, dataObject) => { self._consoleAppend(text, { dataObject: dataObject, logType: "INFO" }); },
            warn: (text, dataObject) => { self._consoleAppend(text, { dataObject: dataObject, logType: "WARN" }); },
            error: (text, dataObject) => { self._consoleAppend(text, { dataObject: dataObject, logType: "ERROR" }); },
            table: (data) => {
                return "<table class=\"hcs-debug-c-table\">" + (
                    (data || []).map(row => {
                        return "<tr>" +
                            "<td>" + self.htmlEscape(Object.keys(row)[0]) + "</td>" +
                            "<td>" + self.htmlEscape(row[Object.keys(row)[0]]) + "</td>" +
                            "</tr>";
                    }
                    )).join("") +
                    "</table>";
            }
        };

        if(this.options.enabled && this.getPanel("console", ".hcs-ecs-toolbar input.hcs-search")) {
            this.getPanel("console", ".hcs-ecs-toolbar input.hcs-search").addEventListener("keyup", (e) => { this.consoleSearch.call(this, e); });
            this.getPanel("console", ".hcs-ecs-toolbar button.hcs-filter-clear").addEventListener("click", (e) => { this.consoleSearch.call(this, e, "reset"); });
        }
    }

    consoleSearch(event, mode) {
        let searchField = this.getPanel("console", ".hcs-ecs-toolbar input.hcs-search");
        let searchResetButton = this.getPanel("console", ".hcs-ecs-toolbar .hcs-filter-clear");

        let searchText = searchField.value.trim().toLowerCase();

        let logItems = this.getPanel("console").querySelectorAll(".hcs-log");

        logItems.forEach(logItem => logItem.classList.remove("hcs-hidden"));

        if(["Esc", "Escape"].includes(event.key) || mode === "reset" || searchText === "") {
            searchField.value = "";
            searchResetButton.setAttribute("disabled", "disabled");
            return;
        }

        searchResetButton.removeAttribute("disabled");

        logItems.forEach(logItem => {
            if(logItem.textContent.toLowerCase().indexOf(searchText) < 0) {
                logItem.classList.add("hcs-hidden");
            }
        });
    }

    initJsonLogs() {
        this.jsonLogs = [];

        const logIds = ["ecs", "ecs-resolved", "session", "configHistory", "settings"];

        logIds.forEach(function(logId) {
            this.jsonLogs[logId] = {
                markJs: new MarkJs(this.getPanel(logId, ".hcs-ecs-content")),
                markIndex: 0,
                searchText: null,
                searchResults: []
            };

            if(this.getPanel(logId, ".hcs-ecs-toolbar input.hcs-search")) {
                this.getPanel(logId, ".hcs-ecs-toolbar input.hcs-search").addEventListener("keyup", (e) => { this.ecsSearch.call(this, e, logId, "change"); });
                this.getPanel(logId, ".hcs-ecs-toolbar button.hcs-next").addEventListener("click", (e) => { this.ecsSearch.call(this, e, logId, "next"); });
                this.getPanel(logId, ".hcs-ecs-toolbar button.hcs-prev").addEventListener("click", (e) => { this.ecsSearch.call(this, e, logId, "prev"); });
            }
            this.getPanel(logId, ".hcs-ecs-toolbar button.hcs-copy-clipboard").addEventListener("click", (e) => { this.copyClipboard.call(this, e, logId); });
        }, this);
    } 

    getPanel(tabId, subSelect = null) {
        let selector = ".hcs-tab-content[tabid='" + tabId + "']";

        if(subSelect !== null) {
            selector += " " + subSelect;
        }

        return this.pane.querySelector(selector);
    }

    _consoleAppend(text, options) {
        if(!this.options.enabled) { return; }

        let opts = Object.assign({}, {
            dataObject: null,
            logType: "INFO"
        }, options);

        let className = "hcs-info";
        let iconName = "";

        switch(opts.logType) {
            case "DEBUG":
                className = "hcs-debug";
                iconName = "icn-055-2-settings";
                break;

            case "INFO":
                className = "hcs-info";
                iconName = "icn-029-2-info";
                break;

            case "WARN":
                className = "hcs-warn";
                iconName = "icn-027-2-error";
                break;

            case "ERROR":
                className = "hcs-error";
                iconName = "icn-006-2-less-dot";
                break;
        }

        let consoleContainer = this.getPanel("console", ".hcs-ecs-content");

        let logItem = document.createElement("div");
        logItem.className = "hcs-log " + className;
        logItem.innerHTML = `<debug-icon>
                <svg icon-id="${iconName}" version="2.0">
                    <use href="#${iconName}"></use>
                </svg>
            </debug-icon><em>hcs (${opts.logType}):</em>${text}`;

        consoleContainer.appendChild(logItem);

        if(opts.dataObject) {
            logItem.appendChild(new JSONFormatter(opts.dataObject, 2, {
                animateOpen: false,
                animateClose: false
            }).render());

            // Open URLs in JSON in new tab
            logItem.querySelectorAll(".json-formatter-url").forEach(jsonLink => {
                jsonLink.setAttribute("target", "_blank");
            });
        }

        consoleContainer.scrollTop = consoleContainer.scrollHeight;
    }

    showEcs(ecsString) {
        this.showJsonLog("ecs", ecsString);
    }

    showEcsResolved(ecsString) {
        this.showJsonLog("ecs-resolved", ecsString);
    }

    showSession(sessionString) {
        this.showJsonLog("session", sessionString);
    }

    showConfigHistory(cfgHistory) {
        this.showJsonLog("configHistory", cfgHistory);
    }

    showSettings(settingsString) {
        this.showJsonLog("settings", settingsString);
    }

    showJsonLog(logId, ecsString) {
        if(!this.options.enabled) { return; }

        this.dataLogs[logId] = ecsString;

        let jsonContainer = this.getPanel(logId, ".hcs-ecs-content");
        let sizeStatus = this.getPanel(logId, ".hcs-size");
        sizeStatus.innerHTML = "";

        this.jsonLogs[logId].markJs.unmark();
        this.jsonLogs[logId].markIndex = 0;
        this.jsonLogs[logId].searchText = null;
        this.jsonLogs[logId].searchResults = [];

        if(this.getPanel(logId, ".hcs-ecs-toolbar .hcs-search-result")) {
            this.getPanel(logId, ".hcs-ecs-toolbar .hcs-search-result").style.display = "none";
        }

        jsonContainer.innerHTML = "";
        jsonContainer.appendChild(new JSONFormatter(ecsString, 2, {
            animateOpen: false,
            animateClose: false
        }).render());

        // Open URLs in JSON in new tab
        jsonContainer.querySelectorAll(".json-formatter-url").forEach(jsonLink => {
            jsonLink.setAttribute("target", "_blank");
        });

        this.initItemSelector(jsonContainer);

        if((typeof ecsString !== "undefined") && ecsString !== null) {
            let ecsToString = typeof (ecsString) !== "string" ? JSON.stringify(ecsString) : ecsString;

            sizeStatus.innerHTML = "Size: " + this.formatFileSize(ecsToString.length);
        }
    }

    initItemSelector(container) {
        let self = this;

        let identItems = Array.from(container.querySelectorAll(".json-formatter-key"))
            .filter(el => el.innerHTML === "ident:")
            .map(el => el.nextElementSibling);

        if(typeof identItems !== "undefined") {
            identItems.forEach((item) => {
                item.classList.add("hcs-debug-hlgt");

                item.addEventListener("click", () => {
                    let ident = item.innerHTML.replace(/\"/g, "");

                    let selectedItem = container.querySelector(".hcs-debug-hlgt.hcs-highlight");
                    if(selectedItem) { selectedItem.classList.remove("hcs-highlight"); }

                    if(self.options.identSelected.call(self, ident)) {
                        item.classList.add("hcs-highlight");
                    }
                });
            });
        }
    }

    copyClipboard(event, logId) {
        let tempTextArea = document.createElement("textarea");
        tempTextArea.style.border = "none";
        tempTextArea.style.overflow = "hidden";

        this.options.hcs.api.instance("#hcs-debug").appendChild(tempTextArea);

        try {
            tempTextArea.innerHTML = JSON.stringify(this.dataLogs[logId]);

            tempTextArea.select();
            navigator.clipboard.writeText(tempTextArea.value);
        } catch(e) { }

        tempTextArea.remove();
    }

    ecsSearch(event, logId, mode) {
        let searchText = this.getPanel(logId, ".hcs-ecs-toolbar input").value.trim();
        
        switch(mode) {
            case "change":
                switch(event.key) {
                    case "Enter":
                        mode = "next";
                        break;

                    case "Esc":
                    case "Escape":
                        this.getPanel(logId, ".hcs-ecs-toolbar input").value = "";
                        this.jsonLogs[logId].markJs.unmark();
                        this.jsonLogs[logId].markIndex = 0;
                        this.jsonLogs[logId].searchText = null;
                        this.jsonLogs[logId].searchResults = [];
                        this.getPanel(logId, ".hcs-ecs-toolbar .hcs-search-result").style.display = "none";
                        return;

                    default:
                        this.getPanel(logId, ".hcs-ecs-toolbar button.hcs-next").disabled = (searchText !== "") ? null : "disabled";
                        this.getPanel(logId, ".hcs-ecs-toolbar button.hcs-prev").disabled = (searchText !== "") ? null : "disabled";
                        return;
                }
        }

        if(searchText !== this.jsonLogs[logId].searchText) {
            this.jsonLogs[logId].markJs.unmark();
            this.jsonLogs[logId].markIndex = 0;

            if(searchText !== "") {
                this.jsonLogs[logId].markJs.mark(searchText, {
                    className: "hcs-js-mark"
                });

                this.jsonLogs[logId].searchResults = this.getPanel(logId, ".hcs-ecs-content").getElementsByClassName("hcs-js-mark");
                this.getPanel(logId, ".hcs-ecs-toolbar .hcs-search-result").style.display = "inline";
                this.getPanel(logId, ".hcs-ecs-toolbar .hcs-search-result em").innerHTML = this.jsonLogs[logId].searchResults.length;

                if(this.jsonLogs[logId].searchResults.length > 0) {
                    this.jsonLogs[logId].searchResults[0].classList.add("hcs-sel");
                    this.jsonLogs[logId].searchResults[0].scrollIntoView({
                        behavior: "auto",
                        block: "center",
                        inline: "center"
                    });
                }
            }

            this.jsonLogs[logId].searchText = searchText;
        } else {
            if(searchText !== "") {
                if(this.jsonLogs[logId].searchResults.length) {
                    this.jsonLogs[logId].searchResults[this.jsonLogs[logId].markIndex].classList.remove("hcs-sel");

                    switch(mode) {
                        case "next":
                            this.jsonLogs[logId].markIndex++;

                            if(this.jsonLogs[logId].markIndex > this.jsonLogs[logId].searchResults.length - 1) {
                                this.jsonLogs[logId].markIndex = 0;
                            }
                            break;

                        case "prev":
                            this.jsonLogs[logId].markIndex--;

                            if(this.jsonLogs[logId].markIndex < 0) {
                                this.jsonLogs[logId].markIndex = this.jsonLogs[logId].searchResults.length - 1;
                            }
                            break;
                    }
                    
                    this.jsonLogs[logId].searchResults[this.jsonLogs[logId].markIndex].classList.add("hcs-sel");
                    this.jsonLogs[logId].searchResults[this.jsonLogs[logId].markIndex].scrollIntoView({
                        behavior: "auto",
                        block: "center",
                        inline: "center"
                    });
                }
            }
        }
    }

    changeTab(tabId) {
        if(arguments.length < 1) {
            let currentTab = this.pane.querySelector("nav > button.hcs-active");
            return currentTab ? currentTab.getAttribute("tabid") : null;
        }

        this.pane.querySelector("nav > button.hcs-active").classList.remove("hcs-active");
        this.pane.querySelector("nav > button[tabid='" + tabId + "']").classList.add("hcs-active");

        this.pane.querySelectorAll(".hcs-tab-content").forEach((element) => {
            let cTabId = element.getAttribute("tabid");

            if(cTabId === tabId) {
                element.classList.add("hcs-active");
            } else {
                element.classList.remove("hcs-active");
            }
        });

        this.settings({
            currentTab: tabId
        });
    }

    onTouchDown(e) {
        this.onDown(e.touches[0]);
        e.preventDefault();
    }

    onTouchMove(e) {
        this.onMove(e.touches[0]);
    }

    onTouchEnd(e) {
        if(e.touches.length === 0) this.onUp(e.changedTouches[0]);
    }

    onMouseDown(e) {
        this.onDown(e);
    }

    onDown(e) {
        let isResizing = this.dnd.onRightEdge || this.dnd.onBottomEdge || this.dnd.onTopEdge || this.dnd.onLeftEdge;

        if(this.canMove() || isResizing) {
            window.document.body.classList.add("hcs-disable-section");
        }

        this.calc(e);

        this.dnd.clicked = {
            x: this.dnd.x,
            y: this.dnd.y,
            cx: e.clientX,
            cy: e.clientY,
            w: this.dnd.b.width,
            h: this.dnd.b.height,
            isResizing: isResizing,
            isMoving: !this.dnd.isResizing && this.canMove(),
            onTopEdge: this.dnd.onTopEdge,
            onLeftEdge: this.dnd.onLeftEdge,
            onRightEdge: this.dnd.onRightEdge,
            onBottomEdge: this.dnd.onBottomEdge
        };
    }

    canMove() {
        return this.dnd.x > 0 && this.dnd.x < this.dnd.b.width && this.dnd.y > 0 && this.dnd.y < this.dnd.b.height && this.dnd.y < this.dnd.titleBarHeight;
    }

    calc(e) {
        this.dnd.b = this.pane.getBoundingClientRect();
        this.dnd.x = e.clientX - this.dnd.b.left;
        this.dnd.y = e.clientY - this.dnd.b.top;

        this.dnd.onTopEdge = this.dnd.y < this.dnd.margins;
        this.dnd.onLeftEdge = this.dnd.x < this.dnd.margins;
        this.dnd.onRightEdge = this.dnd.x >= this.dnd.b.width - this.dnd.margins;
        this.dnd.onBottomEdge = this.dnd.y >= this.dnd.b.height - this.dnd.margins;

        this.dnd.rightScreenEdge = window.innerWidth - this.dnd.margins;
        this.dnd.bottomScreenEdge = window.innerHeight - this.dnd.margins;
    }

    onMove(e) {
        this.calc(e);
        this.dnd.mouseMoveEvent = e;
        this.dnd.redraw = true;
    }

    animate() {
        if(!this.dnd.enabled) {
            this.pane.style.cursor = "default";
            return;
        }

        requestAnimationFrame(() => { this.animate.call(this); });

        if(!this.dnd.redraw) return;

        this.dnd.redraw = false;

        if(this.dnd.clicked && this.dnd.clicked.isResizing) {
            if(this.dnd.clicked.onRightEdge) this.pane.style.width = Math.max(this.dnd.x, this.options.minWidth) + "px";
            if(this.dnd.clicked.onBottomEdge) this.pane.style.height = Math.max(this.dnd.y, this.options.minHeight) + "px";

            if(this.dnd.clicked.onLeftEdge) {
                let currentWidth = Math.max(this.dnd.clicked.cx - this.dnd.mouseMoveEvent.clientX + this.dnd.clicked.w, this.options.minWidth);

                if(currentWidth > this.options.minWidth) {
                    this.pane.style.width = currentWidth + "px";
                    this.pane.style.left = this.dnd.mouseMoveEvent.clientX + "px";
                }
            }

            if(this.dnd.clicked.onTopEdge) {
                let currentHeight = Math.max(this.dnd.clicked.cy - this.dnd.mouseMoveEvent.clientY + this.dnd.clicked.h, this.options.minHeight);

                if(currentHeight > this.options.minHeight) {
                    this.pane.style.height = currentHeight + "px";
                    this.pane.style.top = this.dnd.mouseMoveEvent.clientY + "px";
                }
            }

            return;
        }

        if(this.dnd.clicked && this.dnd.clicked.isMoving) {
            this.pane.style.top = (this.dnd.mouseMoveEvent.clientY - this.dnd.clicked.y) + "px";
            this.pane.style.left = (this.dnd.mouseMoveEvent.clientX - this.dnd.clicked.x) + "px";
            return;
        }

        if(this.dnd.onRightEdge && this.dnd.onBottomEdge || this.dnd.onLeftEdge && this.dnd.onTopEdge) {
            this.pane.style.cursor = "nwse-resize";
        } else if(this.dnd.onRightEdge && this.dnd.onTopEdge || this.dnd.onBottomEdge && this.dnd.onLeftEdge) {
            this.pane.style.cursor = "nesw-resize";
        } else if(this.dnd.onRightEdge || this.dnd.onLeftEdge) {
            this.pane.style.cursor = "ew-resize";
        } else if(this.dnd.onBottomEdge || this.dnd.onTopEdge) {
            this.pane.style.cursor = "ns-resize";
        } else if(this.canMove()) {
            this.pane.style.cursor = "move";
        } else {
            this.pane.style.cursor = "default";
        }
    }

    onUp(e) {
        window.document.body.classList.remove("hcs-disable-section");
        this.calc(e);
        this.dnd.clicked = null;
    }

    formatFileSize(value, digits = 2) {
        if(value <= 0) {
            return "0kB";
        }

        var digitGroups = parseInt((Math.log(value) / Math.log(10)) / (Math.log(1024) / Math.log(10)));

        return this.roundExt(value / Math.pow(1024, digitGroups), digits).toLocaleString("en-US") + ["B", "kB", "MB", "GB", "TB"][digitGroups];
    }

    roundExt(number, digits) {
        return Math.round(number * Math.pow(10, digits)) / Math.pow(10, digits);
    }

    settings(data) {
        const storageKey = "debug-window";

        if(!this.options.hcs.api.storage.local(storageKey)) {
            this.options.hcs.api.storage.local(storageKey, JSON.stringify({
                currentTab: null
            }));
        }

        let currentData = JSON.parse(this.options.hcs.api.storage.local(storageKey));

        if(arguments.length > 0) {
            currentData = objectAssignDeep({}, currentData, data);
            this.options.hcs.api.storage.local(storageKey, JSON.stringify(currentData));
        }

        return currentData;
    }
}